/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  MRT_Cell,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  PaginationItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tabs,
  Tab,
  useTheme,
  Menu,
  MenuItem,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import PlusWhiteStroke from 'packages/novous_web/src/assets/icons/PlusWhiteStroke.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import edit from 'packages/novous_web/src/assets/icons/edit.svg';
import deleteIcon from 'packages/novous_web/src/assets/icons/Delete.svg';
import Devices from 'packages/novous_web/src/assets/icons/Devices.svg';
import dayjs from 'dayjs';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import { useToast } from 'packages/novous_web/src/context/ToastContext';
// import CustomiseDeviceTableModal from './CustomiseDeviceTableModal';
import BulkUploadModal from 'packages/novous_web/src/common/components/BulkUpload';
import { dayCount } from 'packages/novous_web/src/utils/helper';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import FilterDeviceModal from './FilterDeviceModal';
import { PageLoader } from 'packages/novous_web/src/common/components';
import { useLocation } from 'react-router-dom';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import menu from 'packages/novous_web/src/assets/icons/menu.svg';
// import turnOnIcon from 'packages/novous_web/src/assets/images/red stop.png';
// import turnOffIcon from 'packages/novous_web/src/assets/images/green start.png';
import useApiError from 'packages/novous_web/src/api/useApiError';
import { SdCard } from '@mui/icons-material';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};
interface Device {
  deviceId: string;
  vehicleRegistrationNo: string;
  version: string;
  totalUsedMb: string;
  deviceName: string;
  deviceType: string;
  updatedTime: string;
  lastAlarmDataTime: string;
  gpsStatus: number;
  sdCardStatus: number;
  dmsCameraStatus: number;
  fcwCameraStatus: number;
  powerTamperingStatus: number;
  createdAt: string;
  expirationDate: string;
  dataSource: string;
}

const initialColumnObj = {
  deviceId: { name: 'Device ID', status: true },
  vehicleRegistrationNo: { name: 'Vehicle Reg No.', status: true },
  version: { name: 'Version', status: true },
  totalUsedMb: { name: 'Used Data (in MB)', status: true },
  deviceName: { name: 'Device Name', status: true },
  deviceType: { name: 'Device Type', status: true },
  updatedTime: { name: 'Last Updated Time', status: true },
  lastAlarmDataTime: { name: 'Last Update Aging (Day)', status: true },
  gpsStatus: { name: 'GPS Status', status: true },
  sdCardStatus: { name: 'SD Card Status', status: true },
  dmsCameraStatus: { name: 'DMS Camera Status', status: true },
  fcwCameraStatus: { name: 'FCW Camera Status', status: true },
  powerTamperingStatus: { name: 'Power Tampering Status', status: true },
  createdAt: { name: 'Installed Date', status: true },
  expirationDate: { name: 'Expiration Date', status: true },
  actions: { name: 'Actions', status: true },
};
interface DataTableProps {
  handleTile: (data: ColumnObjType) => void;
}

const DeviceDataTable: React.FC<DataTableProps> = ({ handleTile }) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  // Note: Wake-up status is now tracked using predefined fields:
  // "isDeviceWakeupTriggered": false,
  // "deviceWakeupTriggered": false,

  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<Device[]>([]);
  const [filteredData, setFilteredData] = useState<Device[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDevice, setSelectedDevice] = useState<any>(null);
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const [pagesData, setPagesData] = useState<Device[][]>([]);
  const paginatedArr = useRef<any[]>([null]);
  const pageSize = 10;
  const { user } = useAuth();
  const navigate = useNavigate();
  const debouncedSearchQuery = useDebounce(searchQuery, 200);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete modal
  const [deleteingDevice, setDeletingDevice] = useState<{
    groupName?: string;
  } | null>(null);
  const { showToast } = useToast();

  const theme = useTheme();
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [columnObj, setColumnObj] = useState<ColumnObjType>(initialColumnObj);
  const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
  const [driverDoc, setDriverDoc] = useState<any>();
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const [wakeupSendingDeviceIds, setWakeupSendingDeviceIds] = useState<string[]>([]);
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const handleFilterOpen = () => setIsFilterModelOpen(true);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Total Devices', status: true },
    Stat2: { name: 'Active devices', status: true },
    Stat3: { name: 'Faulty Devices', status: true },
    Stat4: { name: 'Under maintenance', status: true },
  });

  const filterDataFromLocation = location?.state?.filterData?.data || { data: {}, isfiltered: false };

  console.log('filterDataFromLocation:', filterDataFromLocation);

  const [filterData, setFilterData] = useState(null);

  const {
    data: downloadDeviceData,
    error: downloadDeviceError,
    loading: downloadDeviceLoading,
    fetchData: fetchDownloadDeviceData,
  } = useApiError<any>(`${API_ENDPOINTS.directories.DEVICE_DOWNLOAD}`, 'POST', 'blob');
  const {
    data: deviceData,
    error: deviceError,
    loading: deviceLoading,
    fetchData: fetchDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_DEVICES}`, 'POST');
  const {
    data: deviceDeleteData,
    error: deviceDeleteError,
    loading: deviceDeleteLoading,
    fetchData: deleteDevice,
  } = useAxios<any>(`${API_ENDPOINTS.directories.DEVICE_DELETE}`, 'POST');

  const {
    data: wakeupDeviceData,
    error: wakeupDeviceError,
    loading: wakeupDeviceLoading,
    fetchData: fetchWakeupDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.WAKEUP_DEVICE}`, 'POST');

  const {
    data: sleepDeviceData,
    error: sleepDeviceError,
    loading: sleepDeviceLoading,
    fetchData: fetchSleepDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.SLEEP_DEVICE}`, 'POST');

  useEffect(() => {
    if (location?.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    }
  }, [location?.state?.activeTab]);

  useEffect(() => {
    if (activeTab === 1 && data.length > 0) {
      const faultyDevices = data.filter(
        (item: any) => item.errorStatus === 1 && item.powerTamperingStatus === 1,
      );
      setFilteredData(faultyDevices);
    } else if (activeTab === 0 && data.length > 0) {
      setFilteredData(data);
    }
  }, [activeTab, data]);

  useEffect(() => {
    if (deviceDeleteError || deviceError || downloadDeviceError) {
      showToast(deviceDeleteError || deviceError || downloadDeviceError || 'Something went wrong!', 'error');
    }
  }, [deviceDeleteError, deviceError, downloadDeviceError]);

  useEffect(() => {
    if (wakeupDeviceData?.status === 200) {
      showToast(wakeupDeviceData?.message, 'success');
      if (selectedDevice?.vehicleRegistrationNo) {
        const doneId = selectedDevice.vehicleRegistrationNo;
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== doneId));
      }
      setAnchorEl(null);
      if (selectedDevice && user?.customer_id) {
        const payloads: any = { fleetId: user?.customer_id, lastEvaluatedKey: null };
        if(filterDataFromLocation.vehicleGroup){
          payloads.vehicleGroup = filterDataFromLocation.vehicleGroup;
        }
        fetchDeviceData(payloads);
      }
    } else if (wakeupDeviceError) {
      showToast('Error occurred while sending wake-up command to device.', 'error');
      if (selectedDevice?.vehicleRegistrationNo) {
        const errorId = selectedDevice.vehicleRegistrationNo;
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== errorId));
      }
      setAnchorEl(null);
    }
  }, [wakeupDeviceData, wakeupDeviceError]);

  useEffect(() => {
    if (sleepDeviceData?.status === 200) {
      showToast(sleepDeviceData?.message, 'success');
      if (selectedDevice && user?.customer_id) {
        const payloads: any = { fleetId: user?.customer_id, lastEvaluatedKey: null };
        if(filterDataFromLocation.vehicleGroup){
          payloads.vehicleGroup = filterDataFromLocation.vehicleGroup;
        }
        fetchDeviceData(payloads);
      }
    } else if (sleepDeviceError) {
      showToast('Error occurred while sending sleep command to device.', 'error');
    }
  }, [sleepDeviceData, sleepDeviceError]);

  // Filter Handler
  const handleFilterSave = (filters: any) => {
    if (filters.group || filters.device) {
      setFilterData(filters);
    } else {
      setFilterData(null);
    }
  };
  useEffect(() => {
    if (filterData) {
      const applyFilters = (dataList: any[], filters: any) => {
        return dataList.filter(
          (item) =>
            (filters.group ? item.groupName === filters.group : true) &&
            (filters.device ? item.deviceType === filters.device : true),
        );
      };
      const filteredResults = applyFilters(deviceData?.data, filterData);
      setFilteredData(filteredResults); // Set the filtered array, NOT the function
    } else {
      setFilteredData(deviceData?.data); // Set the filtered array, NOT the function
    }
  }, [filterData]);

  const handleReset = () => {
    setTilesObj({
      // Stat1: { name: "Total Ignition Trips", status: true },
      Stat1: { name: 'Total Devices', status: true },
      Stat2: { name: 'Active devices', status: true },
      Stat3: { name: 'Faulty Devices', status: true },
      Stat4: { name: 'Under maintenance', status: true },
    });
  };
  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);

  // Download handler

  useEffect(() => {
    if (downloadDeviceData) {
      try {
        if (downloadDeviceData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadDeviceData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `device_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadDeviceData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };
  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };
  // const handleDownload = async () => {
  //     fetchDownloadDeviceData({ fleetId: user?.customer_id, fileType: selectedFormat });
  // };

  const handleDownload = async () => {
    setIsSendingEmail(true);
    const requestData = {
      fleetId: user?.customer_id,
      fileType: selectedFormat,
    };

    try {
      const response = await fetchDownloadDeviceData(requestData);
      if (
        response?.type === 'text/csv' ||
        response?.type === 'application/pdf' ||
        response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setAlertMessage(`File has been downloaded successfully`);
        setAlertType('success');
        setAlertOpen(true);
      } else {
        setAlertMessage(response?.error);
        setAlertType('error');
        setAlertOpen(true);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setAlertMessage((error as Error).message);
      setAlertType('error');
      setAlertOpen(true);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const handleViewDetails = () => {
    console.info('View IconButton clicked', selectedDevice);
    if (selectedDevice) {
      navigate('details', { state: selectedDevice });
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  const handleEditClick = () => {
    console.info('Edit IconButton clicked');
    if (selectedDevice) {
      navigate(`./edit/${selectedDevice.deviceId}`);
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  const handleWakeupDevice = async () => {
    if (selectedDevice && !isWakeUpDeviceEnabled(selectedDevice)) {
      const currentVehicleId = selectedDevice.vehicleRegistrationNo;
      const payload = {
        vehicleId: currentVehicleId,
        fleetId: user?.customer_id,
      };
      setWakeupSendingDeviceIds((prev) =>
        prev.includes(currentVehicleId) ? prev : [...prev, currentVehicleId],
      );
      try {
        await fetchWakeupDeviceData(payload);
      } catch (e) {
        // Toast handled in effect
      } finally {
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== currentVehicleId));
        setAnchorEl(null);
      }
    }
  };

  const handleSleepDevice = () => {
    if (selectedDevice && isWakeUpDeviceEnabled(selectedDevice)) {
      const payload = {
        vehicleId: selectedDevice.vehicleRegistrationNo,
        fleetId: user?.customer_id,
      };
      fetchSleepDeviceData(payload);
      setAnchorEl(null);
    }
  };
  // Check if wake-up was triggered for this device using predefined fields
  const isWakeUpDeviceEnabled = (device: any) => {
    if (!device) return false;
    // Check either of the predefined boolean fields
    return device.isDeviceWakeupTriggered === true || device.deviceWakeupTriggered === true;
  };

  const handleDeleteClickHandler = () => {
    console.info('Delete IconButton clicked');
    if (selectedDevice) {
      handleDeleteClick(selectedDevice);
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  // Customise handler
  const handleOpen = () => setIsCustomiseModalOpen(true);
  const viewMenuData = [
    { name: 'View Details', icon: eye, click: handleViewDetails },
    // { name: 'Edit Device', icon: edit, click: handleEditClick },
    // {name : 'Delete Device', icon: deleteIcon, click: handleDeleteClickHandler},
    // Show Wake-up and Sleep Device buttons only when dataSource === 'android'
    ...(selectedDevice?.dataSource === 'android'
      ? [
          {
            name:
              selectedDevice && wakeupSendingDeviceIds.includes(selectedDevice.vehicleRegistrationNo)
                ? 'Sending Command...'
                : 'Wake-up Device',
            icon: require('packages/novous_web/src/assets/images/green start.png'),
            click: handleWakeupDevice,
            disabled:
              (selectedDevice && wakeupSendingDeviceIds.includes(selectedDevice.vehicleRegistrationNo)) ||
              isWakeUpDeviceEnabled(selectedDevice),
          },
          {
            name: 'Sleep Device',
            icon: require('packages/novous_web/src/assets/images/red stop.png'),
            click: handleSleepDevice,
            disabled: !isWakeUpDeviceEnabled(selectedDevice),
          },
        ]
      : []),
    // { name: 'Delete Vehicle', icon: deleteIcon, click: handleDeleteClickHandler, disabled: false },
  ];

  // Bulk Upload handler
  const handleUploadModalClose = () => {
    setIsUploadModelOpen(false);
    const resetPayload: any = { fleetId: user?.customer_id, lastEvaluatedKey: null };
    if(filterDataFromLocation.vehicleGroup){
      resetPayload.vehicleGroup = filterDataFromLocation.vehicleGroup;
    }
    fetchDeviceData(resetPayload);
  };

  // Delete handler
  const DeleteDevice = () => {
    deleteDevice(deleteingDevice);
  };
  const handleDeleteClick = (device: any) => {
    setIsDeleteModalOpen(true); // Open delete confirmation modal
    setDeletingDevice(device);
  };
  const handleDeleteConfirm = () => {
    DeleteDevice(); // Call delete endpoint
    setIsDeleteModalOpen(false); // Close modal
    setDeletingDevice(null);
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false); // Close modal without deleting
    setDeletingDevice(null);
  };
  // useEffect(() => { // commented this as we have commented the delete functionality as of now!
  //     if (deviceDeleteData?.message) {
  //         showToast(deviceDeleteData?.message, deviceDeleteData?.data);
  //     }

  //     if (deviceData?.data?.lastEvaluatedKey) {
  //         fetchDeviceData({ fleetId: user?.customer_id, lastEvaluatedKey: deviceData?.data?.lastEvaluatedKey });
  //     } else {
  //         fetchDeviceData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
  //     }
  // }, [deviceDeleteData])

  useEffect(() => {
    if (user?.customer_id) {
      console.info('fetchDeviceData: useEffect');
      const payloads: any = { fleetId: user?.customer_id, lastEvaluatedKey: null };
      if(filterDataFromLocation.vehicleGroup){
        payloads.vehicleGroup = filterDataFromLocation.vehicleGroup;
      }
      fetchDeviceData(payloads);
    }
  }, [user?.customer_id]);

  useEffect(() => {
    if (deviceData?.data) {
      const getDeviceNameFromDataSource = (dataSource: string): string => {
        if (dataSource === 'vp2') {
          return 'Novus Safe Lite';
        } else if (dataSource === 'android') {
          return 'Novus Safe Pro';
        }
        return 'N/A';
      };

      const deviceListData: Device[] = deviceData?.data?.map((device: any) => ({
        deviceId: device.deviceId,
        vehicleRegistrationNo: device.vehicleRegistrationNo,
        version: device.version || 'N/A',
        totalUsedMb: device.totalUsedMb || 'N/A',
        deviceName: getDeviceNameFromDataSource(device.dataSource),
        deviceType: device.deviceType || 'N/A',
        updatedTime: device.updatedTime || 'N/A',
        lastAlarmDataTime: device.lastAlarmDataTime || 'N/A',
        gpsStatus: device.gpsStatus || 0,
        sdCardStatus: device.sdCardStatus || 0,
        dmsCameraStatus: device.dmsCameraStatus || 0,
        fcwCameraStatus: device.fcwCameraStatus || 0,
        powerTamperingStatus: device.powerTamperingStatus || 0,
        createdAt: device.createdAt || 'N/A',
        expirationDate: device.expirationDate,
        dataSource: device.dataSource,
        ...device,
      }));
      setData(deviceListData);
    }
  }, [deviceData]);

  useEffect(() => {
    if (deviceData?.data?.lastEvaluatedKey) {
      if (paginatedArr.current.length === currentPage) {
        paginatedArr.current.push(deviceData.data.lastEvaluatedKey);
      }
    }
  }, [deviceData]);

  // item.deviceId.toLowerCase().includes(searchQuery.toLowerCase())

  //  Search option
  useEffect(() => {
    if (debouncedSearchQuery) {
      const filteredDataArr = data.filter(
        (item) =>
          item.deviceId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.vehicleRegistrationNo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (item.deviceName && item.deviceName.toLowerCase().includes(searchQuery.toLowerCase())) ||
          item.deviceType?.toLowerCase().includes(searchQuery.toLowerCase()),
        // (item.createdAt ? item.createdAt.toLowerCase().includes(searchQuery.toLowerCase()) : false) ||
        // (item.updatedTime ? item.updatedTime.toLowerCase().includes(searchQuery.toLowerCase()) : false) ||
        // (item.createdAt ? item.createdAt.toLowerCase().includes(searchQuery.toLowerCase()) : false) ||
        // (item.expirationDate ? item.expirationDate.toLowerCase().includes(searchQuery.toLowerCase()) : false)
      );
      setFilteredData(filteredDataArr);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchQuery]);

  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
    try {
      if (newValue === 1) {
        const faultyDevices = data.filter(
          (item: any) => item.errorStatus === 1 && item.powerTamperingStatus === 1,
        );
        setFilteredData(faultyDevices);
      } else {
        setFilteredData(data);
      }
    } catch (error) {
      console.error('Error filtering data:', error);
      setFilteredData([]); // Fallback to empty array on error
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Handler for changing pages.
  useEffect(() => {
    if (deviceData) {
      setPagesData((prev) => {
        const newPages = [...prev];
        newPages[currentPage - 1] = deviceData.data;
        return newPages;
      });
    }
  }, [deviceData, currentPage]);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    return filteredData.slice(start, end);
  }, [filteredData, currentPage]);

  useEffect(() => {
    if (deviceData?.data?.lastEvaluatedKey) {
      if (!paginatedArr.current.includes(deviceData.data.lastEvaluatedKey)) {
        paginatedArr.current.push(deviceData.data.lastEvaluatedKey);
      }
    }
  }, [deviceData]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };
  const formatDateTime = (dateTimeStr: string): string => {
    return dayjs(dateTimeStr).format('DD MMM, YYYY hh:mm A'); // Example: "11 Nov, 2024 05:03 PM"
  };

  // Table Option ---------------
  const allColumns: MRT_ColumnDef<Device>[] = useMemo(() => {
    return [
      {
        accessorKey: 'deviceId',
        header: 'Device ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'vehicleRegistrationNo',
        header: 'Vehicle Reg No.',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'version',
        header: 'Version',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() || 'N/A'}
          </Typography>
        ),
      },
      {
        accessorKey: 'totalUsedMb',
        header: 'Used Data (in MB)',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell, row }) => {
          const value = cell.getValue<number>();
          const dataSource = row.original.dataSource; // Access the dataSource field from the row
          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {dataSource === 'android' && value !== null && value !== undefined ? value.toFixed(2) : 'N/A'}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'deviceName',
        header: 'Device Name',
        enableColumnActions: false,
        size: isSmallScreen ? 120 : 200,
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() || 'N/A'}
          </Typography>
        ),
      },
      {
        accessorKey: 'deviceType',
        header: 'Device Type',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'updatedTime',
        header: 'Last Updated Time',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() && formatDateTime(cell.getValue<string>())}
          </Typography>
        ),
      },
      {
        accessorKey: 'lastAlarmDataTime',
        header: 'Last Update Aging (Day)',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ row }) => {
          return (
            <Typography
              variant="body2"
              fontWeight={400}
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {dayCount(row.original.updatedTime)}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'gpsStatus',
        header: 'GPS Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'sdCardStatus',
        header: 'SD Card Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'dmsCameraStatus',
        header: 'DMS Camera Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'fcwCameraStatus',
        header: 'FCW Camera Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'powerTamperingStatus',
        header: 'Power Tampering Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const status = cell.getValue();
          let backgroundColor;
          let color = '#219653';
          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          return (
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color: color,
              }}
            >
              <Typography variant="body2" fontWeight={500}>
                {status === 0 ? 'Connected' : 'Disconnected'}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'createdAt',
        header: 'Installed Date',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'expirationDate',
        header: 'Expiration Date',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },

      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <IconButton
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
              onClick={(event) => {
                event.stopPropagation();
                console.info('IconButton clicked', row.original);
                if (row.original) {
                  navigate('details', { state: row.original });
                  // navigate('details', { state: {deviceData} });
                } else {
                  console.error('Row data is undefined');
                }
              }}
            >
              <img src={eye} alt="custom action" width={24} height={24} />
            </IconButton>
            {/* <IconButton
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
                borderRadius: '2px',
              }}
              onClick={(event) => handleOpenMenu(event, row.original)}
            >
              <img src={menu} alt="custom action" />
            </IconButton> */}
          </Box>
        ),
      },
    ];
  }, [isSmallScreen]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, device: any) => {
    console.info(device, 'device IconButton');

    setAnchorEl(event.currentTarget);
    setSelectedDevice(device);
  };

  const columns: MRT_ColumnDef<Device>[] = useMemo(() => {
    return allColumns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [allColumns, columnObj]);

  // Table options
  const tableOptions: MRT_TableOptions<Device> = {
    columns,
    data: paginatedData,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    initialState: {
      columnPinning: {
        left: ['deviceId'],
        right: ['actions'],
      },
    },
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
  };
  const table = useMaterialReactTable(tableOptions);

  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="flex flex-col gap-4 w-full">
        {/* Search Input */}
        <div className=" w-full flex justify-between gap-4 xs:flex-col ">
          <div className="flex gap-2">
            <div className="max-w-[400px]">
              <TextField
                variant="outlined"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search"
                sx={(theme) => ({
                  '& .MuiOutlinedInput-root': {
                    borderColor: theme.palette.action.selected,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%', // Ensure it takes full available height
                  },
                  '& .MuiInputBase-root': {
                    padding: '0rem 1rem',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '0px 12px', // Adjust padding for better spacing
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                  width: {
                    xs: '100%', // full width on extra small screens
                    sm: '300px', // 300px on small screens
                    md: '400px', // 400px on medium and up
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="icon" width={16} height={16} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={(theme) => ({
                        height: '48px', // Ensure full height
                        maxHeight: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderLeft: `1px solid ${theme.palette.action.selected}`,
                        paddingLeft: '8px',
                      })}
                    >
                      <img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24} height={24} />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '14px', // You can adjust this as per Typography variant
                    fontWeight: 500, // Normal text weight
                  },
                }}
              />
            </div>
            {filterData && (
              <CustomIconButton
                text={`Clear Filters (${Object.values(filterData).filter((value) => value !== null).length})`}
                background="transparent"
                outline={false} // Set to true if you want an outline
                textColor="#C83333"
                onClick={() =>
                  handleFilterSave({
                    group: null,
                    device: null,
                  })
                }
              />
            )}
          </div>
          <div className="flex gap-4 flex-wrap">
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false} // Set to true if you want an outline
              onClick={handleOpen}
            />
            <CustomIconButton
              icon={<img src={bulkUpload} alt="Upload" width={24} height={24} />}
              text="Bulk Upload"
              background="transparent"
              variant="outlined"
              onClick={() => setIsUploadModelOpen(true)}
            />
            <CustomIconButton
              icon={
                <img
                  src={download}
                  alt="download"
                  width={16}
                  height={16}
                  style={filteredData.length === 0 ? { filter: 'grayscale(1)', opacity: 0.5 } : undefined}
                />
              }
              text="Download"
              background="transparent"
              variant="outlined"
              isDisabled={filteredData.length === 0}
              onClick={() => setIsDownloadModalOpen(true)}
            />
            <CustomIconButton
              icon={<img src={PlusWhiteStroke} alt="Add" width={20} height={20} />}
              text="Add Device"
              variant="contained"
              onClick={() => navigate('add')}
            />
          </div>
        </div>
        <Box className="flex items-center w-full justify-between">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: theme.palette.selected,
            }}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label="All Devices"
              sx={{
                ...(activeTab === 0
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: '#1B1B1B !important',
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { fontWeight: 400, color: '#1B1B1B !important' }),
              }}
            />
            <Tab
              label="Faulty Devices"
              sx={{
                ...(activeTab === 1
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: '#1B1B1B !important',
                      // color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { fontWeight: 400, color: '#1B1B1B !important' }),
              }}
            />
          </Tabs>
        </Box>
        {!deviceLoading ? (
          <>
            <MaterialReactTable table={table} />
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              {viewMenuData.map((item, index) => {
                const isDisabled = item.disabled;
                return (
                  <MenuItem
                    key={index}
                    onClick={isDisabled ? undefined : item.click}
                    disabled={isDisabled}
                    sx={{
                      opacity: isDisabled ? 0.7 : 1,
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      '&:hover': {
                        backgroundColor: isDisabled ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <div className="flex gap-2 mt-1">
                      <img
                        src={item.icon}
                        alt={item.name}
                        style={{
                          marginRight: 8,
                          width: 20,
                          height: 20,
                        }}
                      />
                      <Typography variant="body2" fontWeight={600}>
                        {item.name}
                      </Typography>
                    </div>
                  </MenuItem>
                );
              })}
            </Menu>
          </>
        ) : (
          <PageLoader />
        )}
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / pageSize) || 1}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Box>
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={isDeleteModalOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Delete Device</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to permanently delete {deleteingDevice?.groupName}? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <DownloadData
        downloadLoading={downloadDeviceLoading}
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadModalClose={handleDownloadModalClose}
        selectedFormat={selectedFormat}
        handleFormatChange={handleFormatChange}
        handleDownload={handleDownload}
        modalTitle="Download Device Data"
        modalDescription="Please select a file format for your download."
        formatLabel="Format"
        formatExcelLabel="Excel"
        formatCsvLabel="CSV"
        formatPdfLabel="PDF"
        cancelButtonText="Cancel"
        downloadButtonText="Download"
      />

      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={() => setIsCustomiseModalOpen(false)}
        title="Customize Your Table"
        description="Choose which sections to display and arrange them the way you like."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
        onReset={handleReset}
        // initialColumnObj={initialColumnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
      />
      {isUploadModelOpen && (
        <BulkUploadModal
          open={isUploadModelOpen}
          handleClose={handleUploadModalClose}
          uploadEndpoint={API_ENDPOINTS.directories.DEVICE_BULK_UPLOAD}
          title="Bulk Upload"
          description="Upload an Excel/CSV files to add multiple devices at once!"
          entityType="devices"
          sampleFileUrl={API_ENDPOINTS.directories.DEVICE_SAMPLE_DOWNLOAD}
        />
      )}

      <FilterDeviceModal
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title={`Filters (${deviceData?.data?.length} Devices)`}
        description="Use the options below to refine your search and find specific device quickly."
        trgtcData={true}
      />
    </>
  );
};

export default DeviceDataTable;
